import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=721cc53e&scoped=true"
import script from "./UserDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDropdown.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UserDropdown.vue?vue&type=style&index=0&id=721cc53e&prod&scoped=true&lang=scss"
import style1 from "./UserDropdown.vue?vue&type=style&index=1&id=721cc53e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721cc53e",
  null
  
)

export default component.exports